import {apiInstance} from "../api";

const route = '/roles';

// «Роли»: roles with their rights; catalog: the sections, flags and apartment fields a role can be given
export class RolesService {
  static async fetchRoles() {
    return apiInstance.get(route);
  }

  static async fetchCatalog() {
    return apiInstance.get(`${route}/catalog`);
  }

  static async create(role) {
    return apiInstance.post(route, role);
  }

  static async update(id, role) {
    return apiInstance.put(`${route}/${id}`, role);
  }

  static async remove(id) {
    return apiInstance.delete(`${route}/${id}`);
  }
}
